import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { YshButtonControlComponent } from "../ysh-button-control/ysh-button-control.component";

@Component({
    selector: 'ysh-modal',
    templateUrl: './ysh-modal.component.html',
    styleUrl: './ysh-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, MatTooltipModule, YshButtonControlComponent]
})
export class YshModalComponent {
  @Input() isVisible: boolean = false;
  @Output() onClose = new EventEmitter();

  didTapClose() {
    this.onClose.emit();
  }
}
